import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AssetPage, EmployeeAsset, WorkflowError } from '../../models/employee-asset.model';
import { EmployeeAssetsService } from '../../services/employee-assets.service';
import { ASSET } from '../common/employee-assets/asset.constants';
import { assetErrorKey, safeServiceUrl, workflowTrackBy } from '../common/employee-assets/asset.helpers';

const CONSUMED_STATUS = 'CONSUMED';
interface ProfileAsset extends EmployeeAsset { displayQuantity: number; }

@Component({selector: 'app-my-profile-assets', templateUrl: './my-profile-assets.component.html',
  styleUrls: ['./my-profile-assets.component.css']})
export class MyProfileAssetsComponent implements OnChanges, OnDestroy {
  @Input() employeeId: string;
  @Input() active = true;
  items: ProfileAsset[] = [];
  constants = ASSET;
  trackBy = workflowTrackBy;
  safeUrl = safeServiceUrl;
  loading = false;
  hasMore = false;
  errorKey = ASSET.empty;
  private page = ASSET.zero;
  private generation = ASSET.zero;
  private disposed = false;
  private request: Subscription;

  constructor(private api: EmployeeAssetsService) {}

  ngOnChanges(): void { if (this.active) { this.load(); } }
  ngOnDestroy(): void { this.disposed = true; this.cancel(); }

  load(more = false): void {
    if (this.disposed || more && this.loading) { return; }
    this.cancel();
    if (!more) { this.items = []; this.page = ASSET.zero; this.hasMore = false; }
    this.errorKey = ASSET.empty;
    if (!this.employeeId) { return; }
    const generation = this.generation;
    const page = more ? this.page + ASSET.one : ASSET.zero;
    this.loading = true;
    this.request = this.api.list({employeeId: this.employeeId, view: ASSET.open, page: page}).subscribe(
      result => { if (this.current(generation)) { this.applied(result, page, more); } },
      error => { if (this.current(generation)) { this.failed(error); } });
  }

  private applied(result: AssetPage, page: number, more: boolean): void {
    const items = ((result && result.items) || []).map(item => Object.assign({}, item, {
      displayQuantity: item.status === CONSUMED_STATUS ? item.quantity : item.remainingQuantity}));
    this.items = more ? this.items.concat(items) : items;
    this.hasMore = !!result && result.hasMore === true;
    this.page = page; this.loading = false;
  }

  private failed(error: WorkflowError): void {
    this.loading = false; this.errorKey = assetErrorKey(error, false);
    if (this.errorKey === ASSET.deniedKey) { this.items = []; this.hasMore = false; }
  }

  private current(generation: number): boolean { return !this.disposed && this.generation === generation; }
  private cancel(): void {
    this.generation++;
    if (this.request) { this.request.unsubscribe(); }
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-profile/my-profile-assets.component.ts